function isConsultant(store) {
  const { user } = store.state.layout
  return user?.consultantFor?.length > 0 || user?.isConsultantManager
}

export default async function({ route, store, redirect }) {
  if (route.path.startsWith('/suporte/')) return
  if (Object.keys(store.state.layout.user).length === 0)
    await store.dispatch('layout/getUserInfos')
  if (isConsultant(store)) {
    redirect('/menu')
    return
  }
}
